import {
  Button,
  DataTable,
  ItemAction,
  Panel,
  useToast,
} from "@validereinc/common-components";
import classNames from "classnames/bind";
import * as PropTypes from "prop-types";
import React, { useState } from "react";
import AddRecipientModal from "../CreateAlertConfiguration/DeliveryStep/AddRecipientModal";
import RemoveRecipientModal from "../CreateAlertConfiguration/DeliveryStep/RemoveRecipientModal";

import AlertingService from "#components/Services/AlertingService";
import styles from "./AlertConfigurationDetail.module.scss";

const cx = classNames.bind(styles);

const RecipientsTab = ({ recipients, refetchData, alertConfigId }) => {
  const [isAddRecipientModalOpen, setIsAddRecipientModalOpen] = useState(false);
  const [defaultEmail, setDefaultEmail] = useState<string | undefined>();
  const [recipientEmailToRemove, setRecipientEmailToRemove] = useState<
    boolean | string
  >("");
  const [recipientData, setRecipientData] = useState<any | undefined>();
  const { toast } = useToast();

  const onOpenRecipientModal = (subscriber?: any) => {
    if (subscriber?.delivery_address) {
      setDefaultEmail(subscriber?.delivery_address);
      setRecipientData(subscriber);
    }

    setIsAddRecipientModalOpen(true);
  };

  const onCloseRecipientModal = () => {
    setIsAddRecipientModalOpen(false);
    setDefaultEmail(undefined);
  };

  const onAddRecipient = (newRecipientEmail) => {
    AlertingService.addSubscriberToAlert(alertConfigId, newRecipientEmail).then(
      () => {
        toast.push({
          intent: "success",
          description: `Successfully added recipient "${newRecipientEmail}".`,
        });

        refetchData();
      }
    );
  };

  const onOpenRemoveRecipientModal = (subscriber) => {
    setRecipientEmailToRemove(subscriber?.delivery_address);
    setRecipientData(subscriber);
  };

  const onCloseRemoveRecipientModal = () => {
    setRecipientEmailToRemove(false);
  };

  const onRemoveRecipient = () => {
    AlertingService.removeSubscriberFromAlert(recipientData?.id).then(() => {
      toast.push({
        intent: "success",
        description: `Successfully removed recipient "${recipientData.delivery_address}".`,
      });

      setRecipientData(undefined);
      refetchData();
    });
  };

  return (
    <>
      <Panel
        title="Recipients"
        actionRow={
          <Button onClick={() => onOpenRecipientModal()}>Add Recipient</Button>
        }
      >
        <DataTable
          headers={[
            {
              label: "Recipient",
              key: "delivery_address",
              renderComponent: ({ item }) => (
                <p className={cx("email")}>{item.delivery_address}</p>
              ),
            },
          ]}
          items={recipients}
          getItemId={(item) => item.id}
          getItemActions={({ item }): ItemAction[] => [
            {
              label: "Remove",
              buttonProps: {
                onClick: () => onOpenRemoveRecipientModal(item),
                icon: "trash",
              },
            },
          ]}
        />
      </Panel>

      <AddRecipientModal
        isOpen={isAddRecipientModalOpen}
        onAdd={onAddRecipient}
        onClose={onCloseRecipientModal}
        defaultEmail={defaultEmail}
      />

      <RemoveRecipientModal
        recipientEmailToRemove={recipientEmailToRemove as string}
        onRemove={onRemoveRecipient}
        onClose={onCloseRemoveRecipientModal}
      />
    </>
  );
};

RecipientsTab.propTypes = {
  recipients: PropTypes.array.isRequired,
  refetchData: PropTypes.func.isRequired,
  alertConfigId: PropTypes.string,
};

export default RecipientsTab;
